import Big from "big.js"

/**
 * Width of an offer row's volume bar, as a percentage of the best row's volume.
 *
 * Never throws. big.js does on a zero divisor and on a non-numeric string, and
 * a throw while rendering one row takes the whole Offers tab down — which is
 * what a Magic Eden pool row did on every Solana collection OLAP had no bids
 * for, because `bestTotalVolume` arrived as 0.
 */
export function volumeBarPercentage(
  totalVolume: string,
  bestTotalVolume: string,
): string {
  try {
    const best = Big(bestTotalVolume)
    if (best.lte(0)) return "0"

    const percentage = Big(totalVolume).div(best).times(100)
    return (percentage.gt(100) ? Big(100) : percentage).toFixed(2)
  } catch {
    return "0"
  }
}
